const KEY_SEPARATOR = '/';

/**
 * Build a condition key from raw path segments. Each segment is encoded to
 * avoid collisions with the separator `/`
 * (e.g. root_subtype "Syringes/Tankers")
 */
export const encodeKey = (segments: string[]): string =>
  segments.map(encodeURIComponent).join(KEY_SEPARATOR);

/** Inverse of {@link encodeKey}: split a key back into its raw segments. */
export const decodeKey = (key: string): string[] =>
  key.split(KEY_SEPARATOR).map(decodeURIComponent);
